import { combineReducers } from 'redux'

import CompanyDataReducer from './companyData'
import UserReducer from './currentUser'
import FiltersReducer from './filters'
import OrgUsersByIdReducer from './orgUsersById'

const customReducers = {
  currentUser: UserReducer,
  companyData: CompanyDataReducer,
  filters: FiltersReducer,
  orgUsersById: OrgUsersByIdReducer
}

export const injectedReducers = Object.entries(customReducers).map(([key, reducer]) => ({
  key,
  reducer
}))

export default combineReducers(customReducers)
